// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"564":"ChunkDocumentCreates","607":"ChunkCore","748":"ChunkReferences","808":"ChunkCart"}[chunkId] + "." + {"564":"a5068c85d0226190890f","607":"0cc2ef29486a970e23be","748":"fce5fd1e673caf0f21d8","808":"9a46c7c98bd93869bf32"}[chunkId] + ".css";
};